<script>
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import TextAccordion from "@js/components/Sections/TextBlocks/TextAccordion.vue";
import CallbackButton from "@js/components/Buttons/CallbackButton.vue";
import CatalogButton from "@js/components/Buttons/CatalogButton.vue";
import {Link} from "@inertiajs/vue3";
import FirstPhone from "@js/components/Sections/Links/FirstPhone.vue";
import Feedbacks from "@js/components/Sections/Feedbacks/Feedbacks.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";

export default {
    name: "AboutCompanyPage",
    components: {Feedbacks, FirstPhone, CatalogButton, CallbackButton, TextAccordion, Breadcrumbs, Link},
    beforeMount() {
        this.themeStore.activateLightTheme()
    },
    setup() {
        const themeStore = useThemeStore()

        return {themeStore}
    }
}
</script>

<template>
    <div class="pt-10">
        <div class="container mx-auto">
            <div class="mb-2 md:mb-5">
                <div class="flex flex-col">
                    <h1 class="text-2xl md:text-2xl font-bold text-black sm:mb-2 order-2 sm:order-1">
                        О компании ООО «Дорожные Плиты»
                    </h1>
                    <Breadcrumbs class="order-1 sm:order-2 mb-2 sm:mb-0"/>
                </div>
                <hr class="mt-3 hidden md:block"/>
                <div class="grid grid-cols-1 md:grid-cols-2 md:gap-5 mt-5">
                    <div>
                        <p class="mb-5">
                            ООО «Дорожные Плиты» – это надежный поставщик железобетонных изделий. Компания
                            специализируется на производстве и продаже дорожных плит, используемых в строительстве
                            дорог, промышленных объектов, подъездных путей и временных площадок.
                        </p>
                        <p class="mb-5">
                            Мы предлагаем широкий ассортимент бетонных плит различных типоразмеров, соответствующих
                            ГОСТ, что гарантирует их долговечность и устойчивость к нагрузкам. Благодаря
                            собственному
                            производству и налаженной логистике, мы обеспечиваем своевременные поставки по Москве и
                            Московской области.
                        </p>
                        <p class="mb-5">
                            ООО «Дорожные Плиты» сотрудничает с строительными компаниями, промышленными
                            предприятиями и
                            частными заказчиками, предоставляя качественные ЖБИ для различных строительных нужд. Мы
                            работаем с любыми объемами заказов, гарантируя надежность продукции и профессиональный
                            подход к каждому клиенту.
                        </p>
                    </div>
                    <div class="flex items-start justify-end max-md:hidden">
                        <img class="h-full object-cover max-w-full rounded-bl-full rounded-tl-full max-h-[350px]"
                             src="@img/about_company/about.webp"
                             alt="Заказать звонок" title="Заказать звонок">
                    </div>
                </div>
                <div class="grid grid-cols-12 gap-y-10 md:gap-10 md:gap-y-0 mt-10">
                    <div class="col-span-12 md:col-span-8 order-2 md:order-1">
                        <div class="mb-5">
                            <h2 class="text-xl font-bold mb-5">
                                Почему выбирают нас:
                            </h2>
                            <ul class="space-y-3 list-disc list-outside text-sm font-medium ms-5">
                                <li>
                                    <div class="font-bold text-base">
                                        Наличие продукции на складе
                                    </div>
                                    Мы располагаем одним из крупнейших складов строительных материалов в Москве (более 5
                                    гектаров). Это позволяет нам обеспечивать бесперебойные поставки и оперативное
                                    выполнение заказов.
                                </li>
                                <li>
                                    <div class="font-bold text-base">
                                        Качество продукции
                                    </div>
                                    Вся наша продукция соответствует стандартам ГОСТ. Мы тщательно отбираем поставщиков
                                    сырья и строго контролируем каждый этап производства. На полигонах работают
                                    квалифицированные специалисты, которые следят за соблюдением всех технологических
                                    процессов. Качество – наш приоритет.
                                </li>
                                <li>
                                    <div class="font-bold text-base">
                                        Гибкие условия сотрудничества
                                    </div>
                                    Мы ценим каждого клиента и готовы учитывать индивидуальные возможности при
                                    формировании условий сотрудничества. Финансовые специалисты компании помогут
                                    подобрать оптимальный вариант взаимодействия, чтобы оно было выгодным для обеих
                                    сторон.
                                </li>
                                <li>
                                    <div class="font-bold text-base">
                                        Комплексное снабжение объектов
                                    </div>
                                    Наш ассортимент включает более 2500 наименований, что позволяет клиентам заказывать
                                    все необходимые строительные материалы в одном месте. Мы предлагаем полное снабжение
                                    строительства – от подготовки площадки до благоустройства территории, а также
                                    составляем удобный график поставок.
                                </li>
                                <li>
                                    <div class="font-bold text-base">
                                        Надежность и опыт
                                    </div>
                                    Мы успешно работаем в строительной отрасли более 25 лет, заслужив репутацию
                                    ответственного и стабильного партнера. За эти годы мы накопили ценный опыт, который
                                    помогает нам эффективно решать задачи клиентов и поддерживать высокий уровень
                                    сервиса.
                                </li>
                                <li>
                                    <div class="font-bold text-base">
                                        Гарантия качества
                                    </div>
                                    Мы уверены в надежности нашей продукции, поэтому в случае необходимости готовы
                                    предоставить замену. Также мы обеспечиваем быструю доставку благодаря собственному
                                    автопарку, включающему более 50 единиц транспорта грузоподъемностью от 1 до 20 тонн.
                                    Оперативность выполнения заказов – один из наших ключевых приоритетов.
                                </li>
                                <li>
                                    <div class="font-bold text-base">
                                        Индивидуальные решения
                                    </div>
                                    Современные технологии и опыт наших специалистов позволяют нам реализовывать
                                    нестандартные проекты в сфере поставок ЖБИ. Если у вас есть особые требования, мы
                                    готовы обсудить детали и предложить оптимальное решение для вашего объекта.
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-span-12 md:col-span-4 order-1 md:order-2">
                        <div
                            class="p-5 border rounded-lg bg-gradient-to-br from-indigo-800 via-indigo-700 to-indigo-600 text-white">
                            <h2 class="text-xl font-bold mb-5">
                                Наши реквизиты:
                            </h2>
                            <ul class="space-y-3 list-disc list-outside text-sm font-medium ms-5">
                                <li class="font-bold text-base">
                                    ИНН — 5003164750
                                </li>
                                <li class="font-bold text-base">
                                    КПП — 500301001
                                </li>
                                <li class="font-bold text-base">
                                    ОГРН — 1245000090752
                                </li>
                                <li class="font-bold text-base">
                                    ОКПО — 54349495
                                </li>
                                <li class="font-bold text-base">
                                    ОКАТО — 46407000000
                                </li>
                                <li class="font-bold text-base">
                                    ОКТМО — 46707000001
                                </li>
                                <li class="font-bold text-base">
                                    Телефон — +7 (901) 417-04-77
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Feedbacks class="pt-10"/>
</template>

<style scoped lang="scss">

</style>
